import { Col, Form, Row } from "react-bootstrap";
import clsx from "clsx";
import React from "react";
function MarginCalculatorGeneralFeeRate({ register,startCalculate }) {
  return (
    <Col sm={12} md={12} lg={6}>
      <div className="custom-table-statement-content my-3">
        <div className="custom-table-setoff-styled mb-3">
          <h3 className="py-3 px-3 text-bold-600 general-title">General Fees Rate</h3>
        </div>
        <Row className="pb-3">
          <Col xs={6} sm={6} md={6} lg={6} xl={6} className="d-flex flex-column mt-2">
            <div className={clsx("custom-card-content-settlement-item-container")}>
              <h4 className="m-0">Stock Financing Rate (%)</h4>
            </div>
          </Col>
          <Col xs={6} sm={6} md={6} lg={6} xl={6} className="d-flex flex-column mt-2">
            <div className={clsx("custom-card-content-settlement-item-container")}>
              <Form.Group>
                <Form.Control className="formControl" type="number" {...register(`mof`,{onChange:startCalculate})} />
              </Form.Group>
            </div>
          </Col>
          <Col xs={6} sm={6} md={6} lg={6} xl={6} className="d-flex flex-column mt-2">
            <div className={clsx("custom-card-content-settlement-item-container")}>
              <h4 className="m-0">Outstanding Amount</h4>
            </div>
          </Col>
          <Col xs={6} sm={6} md={6} lg={6} xl={6} className="d-flex flex-column mt-2">
            <div className={clsx("custom-card-content-settlement-item-container")}>
              <Form.Group>
                <Form.Control className="formControl" type="number" {...register(`outstanding_amount`,{onChange:startCalculate})} />
              </Form.Group>
            </div>
          </Col>
          <Col xs={6} sm={6} md={6} lg={6} xl={6} className="d-flex flex-column mt-2">
            <div className={clsx("custom-card-content-settlement-item-container")}>
              <h4 className="m-0">Margin Value</h4>
            </div>
          </Col>
          <Col xs={6} sm={6} md={6} lg={6} xl={6} className="d-flex flex-column mt-2">
            <div className={clsx("custom-card-content-settlement-item-container")}>
              <Form.Group>
                <Form.Control className="formControl" type="number" {...register(`margin_value`,{onChange:startCalculate})} />
              </Form.Group>
            </div>
          </Col>
          <Col xs={6} sm={6} md={6} lg={6} xl={6} className="d-flex flex-column mt-2">
            <div className={clsx("custom-card-content-settlement-item-container")}>
              <h4 className="m-0">Market Value</h4>
            </div>
          </Col>
          <Col xs={6} sm={6} md={6} lg={6} xl={6} className="d-flex flex-column mt-2">
            <div className={clsx("custom-card-content-settlement-item-container")}>
              <Form.Group>
                <Form.Control className="formControl" type="number" {...register(`market_value`,{onChange:startCalculate})} />
              </Form.Group>
            </div>
          </Col>
          <Col xs={6} sm={6} md={6} lg={6} xl={6} className="d-flex flex-column mt-2">
            <div className={clsx("custom-card-content-settlement-item-container")}>
              <h4 className="m-0">{`Brokerage < 100k (%)`}</h4>
            </div>
          </Col>
          <Col xs={6} sm={6} md={6} lg={6} xl={6} className="d-flex flex-column mt-2">
            <div className={clsx("custom-card-content-settlement-item-container")}>
              <Form.Group>
                <Form.Control className="formControl" type="number" {...register(`brokerage_under_rate`,{onChange:startCalculate})} />
              </Form.Group>
            </div>
          </Col>
          <Col xs={6} sm={6} md={6} lg={6} xl={6} className="d-flex flex-column mt-2">
            <div className={clsx("custom-card-content-settlement-item-container")}>
              <h4 className="m-0">{`Brokerage > 100k (%)`}</h4>
            </div>
          </Col>
          <Col xs={6} sm={6} md={6} lg={6} xl={6} className="d-flex flex-column mt-2">
            <div className={clsx("custom-card-content-settlement-item-container")}>
              <Form.Group>
                <Form.Control className="formControl" type="number" {...register(`brokerage_over_rate`,{onChange:startCalculate})} />
              </Form.Group>
            </div>
          </Col>
          <Col xs={6} sm={6} md={6} lg={6} xl={6} className="d-flex flex-column mt-2">
            <div className={clsx("custom-card-content-settlement-item-container")}>
              <h4 className="m-0">{`Min Brokerage`}</h4>
            </div>
          </Col>
          <Col xs={6} sm={6} md={6} lg={6} xl={6} className="d-flex flex-column mt-2">
            <div className={clsx("custom-card-content-settlement-item-container")}>
              <Form.Group>
                <Form.Control className="formControl" type="number" {...register(`min_brokerage`,{onChange:startCalculate})} />
              </Form.Group>
            </div>
          </Col>
          <Col xs={6} sm={6} md={6} lg={6} xl={6} className="d-flex flex-column mt-2">
            <div className={clsx("custom-card-content-settlement-item-container")}>
              <h4 className="m-0">{`Clearing Fee (%)`}</h4>
            </div>
          </Col>
          <Col xs={6} sm={6} md={6} lg={6} xl={6} className="d-flex flex-column mt-2">
            <div className={clsx("custom-card-content-settlement-item-container")}>
              <Form.Group>
                <Form.Control className="formControl" type="number" {...register(`clearing_fee_rate`,{onChange:startCalculate})} />
              </Form.Group>
            </div>
          </Col>
          <Col xs={6} sm={6} md={6} lg={6} xl={6} className="d-flex flex-column mt-2">
            <div className={clsx("custom-card-content-settlement-item-container")}>
              <h4 className="m-0">{`Max Clearing Fee`}</h4>
            </div>
          </Col>
          <Col xs={6} sm={6} md={6} lg={6} xl={6} className="d-flex flex-column mt-2">
            <div className={clsx("custom-card-content-settlement-item-container")}>
              <Form.Group>
                <Form.Control className="formControl" type="number" {...register(`max_clearing_fee`,{onChange:startCalculate})} />
              </Form.Group>
            </div>
          </Col>
          <Col xs={6} sm={6} md={6} lg={6} xl={6} className="d-flex flex-column mt-2">
            <div className={clsx("custom-card-content-settlement-item-container")}>
              <h4 className="m-0">{`Intraday Rate (%)`}</h4>
            </div>
          </Col>
          <Col xs={6} sm={6} md={6} lg={6} xl={6} className="d-flex flex-column mt-2">
            <div className={clsx("custom-card-content-settlement-item-container")}>
              <Form.Group>
                <Form.Control className="formControl" type="number" {...register(`intraday_rate`,{onChange:startCalculate})} />
              </Form.Group>
            </div>
          </Col>
          <Col xs={6} sm={6} md={6} lg={6} xl={6} className="d-flex flex-column mt-2">
            <div className={clsx("custom-card-content-settlement-item-container")}>
              <h4 className="m-0">{`Stamp Duty Rate (%)`}</h4>
            </div>
          </Col>
          <Col xs={6} sm={6} md={6} lg={6} xl={6} className="d-flex flex-column mt-2">
            <div className={clsx("custom-card-content-settlement-item-container")}>
              <Form.Group>
                <Form.Control className="formControl" type="number" {...register(`stamp_duty`,{onChange:startCalculate})} />
              </Form.Group>
            </div>
          </Col>
          <Col xs={6} sm={6} md={6} lg={6} xl={6} className="d-flex flex-column mt-2">
            <div className={clsx("custom-card-content-settlement-item-container")}>
              <h4 className="m-0">{`Stamp Duty`}</h4>
            </div>
          </Col>
          <Col xs={6} sm={6} md={6} lg={6} xl={6} className="d-flex flex-column mt-2">
            <div className={clsx("custom-card-content-settlement-item-container")}>
              <Form.Group>
                <Form.Control className="formControl" type="number" {...register(`max_stamp_duty`,{onChange:startCalculate})} />
              </Form.Group>
            </div>
          </Col>
          <Col xs={6} sm={6} md={6} lg={6} xl={6} className="d-flex flex-column mt-2">
            <div className={clsx("custom-card-content-settlement-item-container")}>
              <h4 className="m-0">{`Stamp Duty Warrant Rate (%)`}</h4>
            </div>
          </Col>
          <Col xs={6} sm={6} md={6} lg={6} xl={6} className="d-flex flex-column mt-2">
            <div className={clsx("custom-card-content-settlement-item-container")}>
              <Form.Group>
                <Form.Control className="formControl" type="number" {...register(`stamp_duty_ws`,{onChange:startCalculate})} />
              </Form.Group>
            </div>
          </Col>
          <Col xs={6} sm={6} md={6} lg={6} xl={6} className="d-flex flex-column mt-2">
            <div className={clsx("custom-card-content-settlement-item-container")}>
              <h4 className="m-0">{`Max Stamp Duty Warrant`}</h4>
            </div>
          </Col>
          <Col xs={6} sm={6} md={6} lg={6} xl={6} className="d-flex flex-column mt-2">
            <div className={clsx("custom-card-content-settlement-item-container")}>
              <Form.Group>
                <Form.Control className="formControl" type="number" {...register(`max_stamp_duty_ws`,{onChange:startCalculate})} />
              </Form.Group>
            </div>
          </Col>
          {/*<Col xs={6} sm={6} md={6} lg={6} xl={6} className="d-flex flex-column mt-2">*/}
          {/*  <div className={clsx("custom-card-content-settlement-item-container")}>*/}
          {/*    <h4 className="m-0">{`SST (%)`}</h4>*/}
          {/*  </div>*/}
          {/*</Col>*/}
          {/*<Col xs={6} sm={6} md={6} lg={6} xl={6} className="d-flex flex-column mt-2">*/}
          {/*  <div className={clsx("custom-card-content-settlement-item-container")}>*/}
          {/*    <Form.Group>*/}
          {/*      <Form.Control className="formControl" type='number' {...register(`sst`)} />*/}
          {/*    </Form.Group>*/}
          {/*  </div>*/}
          {/*</Col>*/}
        </Row>
      </div>
    </Col>
  );
}

export default MarginCalculatorGeneralFeeRate;
